import React from "react";

type CustomButtonProps = {
  title: string;
  onClick?: () => void;
  titleStyle?: string;
  className?: string;
  disabled?: boolean;
};

const CustomButton: React.FC<CustomButtonProps> = ({
  title,
  className = "",
  titleStyle = "",
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        w-[154px] h-[51px] rounded-[4px]
        flex items-center justify-center
        font-CrimsonText font-bold text-base
        bg-primaryColor text-textColorWhite
        transition-opacity
        ${disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-80"}
        ${titleStyle}
        ${className}
      `}
    >
      {title}
    </button>
  );
};

export default CustomButton;
